import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
// import "./Editor.css";

const Editor = ({ value, onChange, ...props }) => {
  const modules = {
    toolbar: [
      [{ header: [1, 2, 3, 4, 5, 6, false] }],
      [{ font: [] }],
      [{ size: [] }],
      ["bold", "italic", "underline", "strike", "blockquote"],
      [
        { list: "ordered" },
        { list: "bullet" },
        { indent: "+1" },
        { indent: "-1" },
      ],
      ["link", "image", "video"],
    ],
  };

  return (
    <ReactQuill
      value={value}
      onChange={onChange}
      theme="snow"
      style={{ width: "100%", Height: "5%" }}
      modules={modules}
      {...props}
    />
  );
};

export default Editor;
